import { useDialog } from "shared/dialog/use-dialog";
import { EditListDialog } from "../favorite-list-components/edit-list-dialog";
import { usePutApiAccountFavoritesByFavoriteListIdMutation } from "api/generatedApi";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/toast/hooks/use-toast";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { SubmitHandler } from "react-hook-form";

interface Props {
  favoriteListId: string;
  listName: string;
}

export const useEditList = (props: Props) => {
  const { t } = useTranslation();
  const toast = useToast();

  const [openEditListDialog, closeEditListDialog] = useDialog(EditListDialog);
  const [editList] = usePutApiAccountFavoritesByFavoriteListIdMutation();

  const handleSuccess = () => {
    closeEditListDialog();
  };

  const wrapMutation = useMutation({
    onSuccess: handleSuccess,
    successProps: {
      description: t("account.favorites.editListToastSuccess"),
    },
    onError: () => toast.error(t("account.favorites.editListError")),
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit: SubmitHandler<{ name: string }> = (data) => {
    wrapMutation(
      editList({
        favoriteListId: props.favoriteListId,
        updatePersonalFavoriteListRequest: { name: data.name },
      })
    );
  };

  const handleClick = () => {
    openEditListDialog({ onSubmit: handleOnSubmit, name: props.listName });
  };

  return handleClick;
};
